import { FactorType, type SelfServiceLandingPageDataResponse } from '../../api/types';
import { SELF_SERVICE_TIMEOUT } from '@portal/constants';

/**
 * How long an acknowledgement screen's primary button fills before it
 * auto-continues, shared by the face-enrollment and biometric re-consent done
 * screens so both dwell for the same beat.
 *
 * This is the design-system `Button`'s `progressDurationMs`, which both arms the
 * auto-advance and gates the progress fill: without a duration the button renders
 * static and waits for a click. The timer therefore belongs to the button that
 * visualizes it — a separate `setTimeout` would advance the flow with nothing on
 * screen accounting for the wait, and would still fire after a user clicked.
 */
export const DONE_AUTO_CONTINUE_MS = 2000;

export const CONSENT_DOCUMENT_UNAVAILABLE_MESSAGE = 'Failed to load consent document';

export const isFaceEnabled = (landingPageData?: SelfServiceLandingPageDataResponse) => {
  const faceEnrollmentComplete = landingPageData?.authenticators.find(
    el => el.factorType === FactorType.FACE,
  );
  const hasImprivataIdentity = landingPageData?.userInfo.userId;
  const isFaceEntitlementEnabled = landingPageData?.enabledFactors.includes(FactorType.FACE);

  return !faceEnrollmentComplete && hasImprivataIdentity && isFaceEntitlementEnabled;
};

// windowCloseSec is caller-supplied (URL query param) and must not extend the idle
// timeout beyond SELF_SERVICE_TIMEOUT; it can only shorten it.
export const determineWindowCloseTimeoutMins = (windowCloseSec: string | null): number => {
  const parsedSeconds = Number(windowCloseSec);
  return Number.isFinite(parsedSeconds) && parsedSeconds > 0
    ? Math.min(parsedSeconds / 60, SELF_SERVICE_TIMEOUT)
    : SELF_SERVICE_TIMEOUT;
};
